"use client";

import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
import type { ContractOverview } from "../types";
import { shortenAddress } from "@/helpers/address.helpers";
interface NftContractHeaderProps {
  readonly contract: ContractOverview | null;
  readonly onClear: () => void;
  readonly clearable?: boolean | undefined;
}
export function NftContractHeader(t0) {
  const $ = _c(36);
  const {
    contract,
    onClear,
    clearable: t1
  } = t0;
  const clearable = t1 === undefined ? true : t1;
  if (!contract) {
    return null;
  }
  let t2;
  if ($[0] !== contract.address || $[1] !== contract.imageUrl || $[2] !== contract.name) {
    t2 = <div className="tw-relative tw-h-10 tw-w-10 tw-shrink-0 tw-overflow-hidden tw-rounded-lg tw-bg-iron-800">{contract.imageUrl ? <Image src={contract.imageUrl} alt={contract.name ?? contract.address} fill={true} sizes="40px" className="tw-h-full tw-w-full tw-object-cover" /> : <div className="tw-flex tw-h-full tw-w-full tw-items-center tw-justify-center tw-text-xs tw-font-semibold tw-text-iron-500">NFT</div>}</div>;
    $[0] = contract.address;
    $[1] = contract.imageUrl;
    $[2] = contract.name;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== contract.address || $[5] !== contract.name) {
    t3 = contract.name ?? shortenAddress(contract.address);
    $[4] = contract.address;
    $[5] = contract.name;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t3) {
    t4 = <span className="tw-truncate tw-text-sm tw-font-semibold tw-text-iron-100">{t3}</span>;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== contract.tokenType) {
    t5 = contract.tokenType && <span className="tw-inline-flex tw-items-center tw-rounded tw-bg-iron-800 tw-px-1.5 tw-py-0.5 tw-text-[10px] tw-font-medium tw-text-iron-400">{contract.tokenType}</span>;
    $[9] = contract.tokenType;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t4 || $[12] !== t5) {
    t6 = <div className="tw-flex tw-items-center tw-gap-2">{t4}{t5}</div>;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== contract.address) {
    t7 = shortenAddress(contract.address);
    $[14] = contract.address;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t7) {
    t8 = <span className="tw-font-mono">{t7}</span>;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== contract.totalSupply) {
    t9 = contract.totalSupply && <><span className="tw-text-iron-600">•</span><span>{new Intl.NumberFormat("en-US", {
          notation: "compact",
          compactDisplay: "short"
        }).format(Number(contract.totalSupply))}{" "}items</span></>;
    $[18] = contract.totalSupply;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== contract.floorPriceEth) {
    t10 = typeof contract.floorPriceEth === "number" && Number.isFinite(contract.floorPriceEth) && <><span className="tw-text-iron-600">•</span><span>Floor{" "}{contract.floorPriceEth.toLocaleString(undefined, {
          maximumFractionDigits: 3
        })}{" "}ETH</span></>;
    $[20] = contract.floorPriceEth;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== t10 || $[23] !== t8 || $[24] !== t9) {
    t11 = <div className="tw-flex tw-items-center tw-gap-1.5 tw-truncate tw-text-xs tw-text-iron-400">{t8}{t9}{t10}</div>;
    $[22] = t10;
    $[23] = t8;
    $[24] = t9;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  let t12;
  if ($[26] !== t11 || $[27] !== t6) {
    t12 = <div className="tw-flex tw-flex-col tw-gap-0.5 tw-overflow-hidden">{t6}{t11}</div>;
    $[26] = t11;
    $[27] = t6;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  let t13;
  if ($[29] !== clearable || $[30] !== onClear) {
    t13 = clearable && <button type="button" onClick={onClear} className="tw-ml-auto tw-flex tw-h-8 tw-w-8 tw-shrink-0 tw-items-center tw-justify-center tw-rounded-md tw-border-0 tw-bg-transparent tw-text-iron-500 tw-transition-colors hover:tw-bg-iron-800 hover:tw-text-iron-200 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-primary-500/50" aria-label="Clear selection"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" className="tw-h-5 tw-w-5"><path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" /></svg></button>;
    $[29] = clearable;
    $[30] = onClear;
    $[31] = t13;
  } else {
    t13 = $[31];
  }
  let t14;
  if ($[32] !== t12 || $[33] !== t13 || $[34] !== t2) {
    t14 = <section className="tw-group tw-relative tw-flex tw-items-center tw-gap-4 tw-rounded-xl tw-p-3 tw-transition-colors" aria-label="Selected NFT contract">{t2}{t12}{t13}</section>;
    $[32] = t12;
    $[33] = t13;
    $[34] = t2;
    $[35] = t14;
  } else {
    t14 = $[35];
  }
  return t14;
}